import { environment } from "@environments/environment";

export const ROLE_IDS = {
  ADMIN: 54,
  EVALUATOR: 55,
};

export const CSV_URLS = {
  EXAM_SCHEMA_CSV: "",
  TEST_SCHEMA_CSV: "",
  STUDENT_FILE_UPLOAD_SCHEMA_CSV: "",
};

export const TEMPLATE_ID = environment.EVALUATION_WORKFLOW_TEMPLATE_ID;

export const EXAM_SUBMISSIONS_LIMIT = 50;
